module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ababebe088315c098726bb98f6dacd65.jpg";